import { useState } from "react";
import { ProjectCard } from "./project-card";
import { ProjectModal } from "./project-modal";
import { projects, categories } from "../../data/projects";

export default function WorkPage() {
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [selectedProject, setSelectedProject] = useState(null);

  const filteredProjects =
    selectedCategory === "all"
      ? projects
      : projects.filter((project) =>
          project.category.toLowerCase().includes(selectedCategory.toLowerCase())
        );

  return (
    <div className="min-h-screen  text-white p-4 sm:p-6 md:p-12" style={{ background: 'linear-gradient(90deg, rgba(8,7,7,1) 17%, rgba(28,28,28,1) 42%, rgba(8,7,7,1) 75%, rgba(8,7,7,1) 79%, rgba(8,7,7,1) 85%, rgba(8,7,7,1) 92%)' }}>
      <div className="max-w-6xl mx-auto space-y-8 sm:space-y-12">
        <div className="space-y-4 sm:space-y-6">
          <h1 className="text-4xl sm:text-6xl md:text-8xl font-bold tracking-tighter text-white [text-shadow:_0_0_30px_rgba(255,255,255,0.5)]">
            My Work
          </h1>
          <div className="relative max-w-2xl">
            <div className="absolute left-0 top-0 w-1 h-full bg-emerald-500" />
            <p className="text-base sm:text-lg md:text-xl pl-4 sm:pl-6 text-gray-300">
            I have worked on a variety of projects spanning AI, web development, and data analytics. 
            My experience includes building full-stack applications, optimizing user experiences, integrating cloud 
            technologies, and leveraging AI for data-driven insights. I focus on creating innovative and efficient 
            solutions that enhance functionality and engagement across different domains
            </p>
          </div>
        </div>

        {/* Filter Section */}
        <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
          <span className="text-gray-400">Filter By</span>
          <select
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}
            className="w-full sm:w-[180px] bg-black border border-gray-800 text-white p-2 rounded"
          >
            <option value="all">All</option>
            {categories.map((category) => (
              <option key={category.value} value={category.value}>
                {category.label}
              </option>
            ))}
          </select>
        </div>

        {/* Projects Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {filteredProjects.map((project) => (
            <ProjectCard
              key={project.id}
              project={project}
              onClick={() => setSelectedProject(project)}
            />
          ))}
        </div>
      </div>

      {/* Project Details Modal */}
      <ProjectModal
        project={selectedProject}
        isOpen={!!selectedProject}
        onClose={() => setSelectedProject(null)}
      />
    </div>
  );
}
